<template>
  <div class="app-main__inner">
    <TituloComponent icono-titulo="fas fa-pencil-alt" texto-titulo="Editar Situacion de Revista"></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarSituacionRevista()">
          <float-label label="Código:" clase>
            <input
              v-model="situacionRevista.codigo"
              id="codigo"
              placeholder="Ingresar un código..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.situacionRevista.codigo.required
                  ? 'is-invalid'
                  : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.situacionRevista.codigo.required"
              >
                Debe ingresar un código
              </div>
            </template>
          </float-label>
          <float-label label="Descripción:" clase>
            <input
              v-model="situacionRevista.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="(enviado && !$v.situacionRevista.descripcion.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.situacionRevista.descripcion.required"
              >Debe ingresar una descripción</div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from 'vuelidate/lib/validators';
import axios from "axios";
import Swal from "sweetalert2";
import SituacionRevista from "@/models/situacionRevista";
export default {
  name: "EditarSituacionRevista",
  components: {
    TituloComponent,
    FloatLabel,
  },
  data() {
    return {
      situacionRevista: new SituacionRevista(null, "", ""),
      loading: false,
      enviado:false
    };
  },  
  validations:{
    situacionRevista:{
      codigo:{required},
      descripcion:{required},
    }
  },
  mounted() {
    this.situacionRevista.id = this.$route.params.id;
    console.log('situacion revista')
    this.getSituacionRevista();
  },
  methods: {
    getSituacionRevista() {
      this.loading = true;
      axios
        .get("situacionrevista/" + this.situacionRevista.id)
        .then(res => {
          console.log(res.data);
          if (res.data.success) {
            this.situacionRevista = res.data.situacionrevista;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado situacion de revista.`
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarSituacionRevista() {
      this.enviado = true
      this.loading = true;
      this.$v.$touch();
      if(this.$v.$invalid){
        this.loading = false;
        return false;
      }
      axios
        .put("/situacionrevista/" + this.situacionRevista.id, this.situacionRevista)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.situacionrevista.descripcion} se editó con éxito.`
            });
            this.$router.push({ name: "ListarSituacionRevista" });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>